module.exports = __webpack_public_path__ + "static/media/5.a80eab82.jpg";